import { Component, HostListener, OnInit } from "@angular/core";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { StartupService } from "./services/startup.service";
import { Router } from "@angular/router";
import { SettingsService } from "./services/settings.service";
import { UserActivityService } from "./services/useractivity.service";
import { AppRouteData } from "./model/appRoute";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = 'app';
  requireMenu: boolean = true;


  public initCompleted: boolean = false;

  public constructor(
    private titleService: Title,
    private matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly startupService: StartupService,
    private readonly userActivityService: UserActivityService,
    private readonly router: Router,
    private readonly settingsService: SettingsService) {

    this.startupService.initCompleted$.subscribe((result) => {
      this.initCompleted = true;
    });

    this.setTitle("BKS");

    this.matIconRegistry.addSvgIcon(
      "from-gate-a",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "../assets/images/from-gate-a.svg"
      )
    );

    this.matIconRegistry.addSvgIcon(
      "to-gate-a",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "../assets/images/to-gate-a.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "cup-hot",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "../assets/images/cup-hot.svg"
      )
    );

    // unauthenticated resource -> Do not load menu to avoid authentication flow to start
    if (window.location.pathname.toLowerCase() === "/checkin") {
      this.requireMenu = false;
    }
  }

  ngOnInit(): void {
    let hasBeenSentToInactivity = false;
    const onInactive = (): void => {
      if (this.isInactivityCheckSkipped()) {
        console.log("Inactive: skipped, reset timer");
        this.userActivityService.resetTimer();
        return;
      }

      if (hasBeenSentToInactivity) {
        console.log("Inactive: waiting to reactivate");
        return;
      }

      hasBeenSentToInactivity = true;
      this.router.navigate(["/inactivity"]);
    };
    const inactivityInMinutes = this.settingsService.inactivityInMinutes;
    console.log(`Inactive: setting timer to ${inactivityInMinutes} minutes`);
    this.userActivityService.init(inactivityInMinutes, onInactive);
  }

  // This will check if the user is inactive on Pulse window(500ms delay)
  @HostListener('window:mousemove')
  @HostListener('window:keyup')
  @HostListener('window:click')
  private userInteraction() {
    this.userActivityService.resetTimer();
  }

  // Returns true if any active route (parents, nested children and named outlets included) has skipInactivityCheck set in its route data
  private isInactivityCheckSkipped(): boolean {
    const stack = [this.router.routerState.snapshot.root];
    while (stack.length > 0) {
      const route = stack.pop()!;
      if ((route.data as AppRouteData).skipInactivityCheck) {
        return true;
      }
      stack.push(...route.children);
    }
    return false;
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
